import React from 'react';

interface SocialIconsProps {
  light?: boolean;
  dark?: boolean;
}

export function SocialIcons({ light, dark }: SocialIconsProps) {
  return (
    <ul
      className={`betterMood__socialIcons betterMood__socialIcons-${
        light ? 'light' : 'dark'
      }`}>
      <li>
        <a
          href="https://www.facebook.com/bettermoodapp"
          title="Better Mood Facebook Page">
          <svg
            width="30"
            height="30"
            viewBox="0 0 152 152"
            xmlns="http://www.w3.org/2000/svg"
            className={dark ? 'dark' : 'light'}>
            <g data-name="Layer 2">
              <g data-name="Black Icon">
                <path
                  d="M140 0H12A12 12 0 0 0 0 12v128a12 12 0 0 0 12 12h128a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12zM97.62 49.46c0 1.43-.6 2-2 2-2.69 0-5.38 0-8.06.11s-4.14 1.33-4.14 4.13c-.06 3 0 5.94 0 9h11.51c1.64 0 2.2.56 2.2 2.21v12.06c0 1.63-.52 2.14-2.17 2.15H83.32v32.54c0 1.74-.54 2.29-2.26 2.29H68.54c-1.51 0-2.1-.59-2.1-2.1V81.17H56.5c-1.56 0-2.12-.57-2.12-2.14V66.9c0-1.56.59-2.15 2.13-2.15h9.93V56a21.89 21.89 0 0 1 2.73-11.26 16.51 16.51 0 0 1 8.93-7.42A21.91 21.91 0 0 1 85.75 36h9.83c1.41 0 2 .62 2 2 .05 3.85.05 7.66.04 11.46z"
                  data-name="01. Facebook"
                />
              </g>
            </g>
          </svg>
        </a>
      </li>
      <li>
        <a
          href="https://www.instagram.com/bettermoodapp/"
          title="Better Mood Instagram Account">
          <svg
            width="30"
            height="30"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            className={dark ? 'dark' : 'light'}>
            <path
              d="M471.579 0C493.903 0 512 18.097 512 40.421V471.58C512 493.903 493.903 512 471.579 512H40.42C18.097 512 0 493.903 0 471.579V40.42C0 18.097 18.097 0 40.421 0ZM323.75 122h-134.5c-36.984 0-67.25 30.265-67.25 67.248v134.504C122 360.725 152.266 391 189.25 391h134.5c36.984 0 67.25-30.275 67.25-67.248V189.248C391 152.265 360.734 122 323.75 122Zm0 22.417c24.728 0 44.832 20.111 44.832 44.831v134.504c0 24.713-20.104 44.83-44.832 44.83h-134.5c-24.718 0-44.832-20.117-44.832-44.83V189.248c0-24.72 20.114-44.83 44.832-44.83h134.5ZM256.25 189C219.1 189 189 219.103 189 256.248c0 37.131 30.1 67.255 67.25 67.255 37.139 0 67.25-30.124 67.25-67.255 0-37.145-30.111-67.248-67.25-67.248Zm0 22.417c24.758 0 44.832 20.067 44.832 44.831 0 24.765-20.074 44.838-44.832 44.838s-44.832-20.073-44.832-44.838c0-24.764 20.074-44.83 44.832-44.83Zm71.115-41.586c-9.285 0-16.812 7.527-16.812 16.812s7.527 16.812 16.812 16.812 16.813-7.527 16.813-16.812-7.528-16.812-16.813-16.812Z"
              fill="#000"
              fillRule="nonzero"
            />
          </svg>
        </a>
      </li>
      <li>
        <a
          href="https://twitter.com/bettermoodapp"
          title="Better Mood Twitter Account">
          <svg
            width="30"
            height="30"
            viewBox="0 0 152 152"
            xmlns="http://www.w3.org/2000/svg"
            className={dark ? 'dark' : 'light'}>
            <g data-name="Layer 2">
              <g data-name="Black Icon">
                <path
                  d="M140 0H12A12 12 0 0 0 0 12v128a12 12 0 0 0 12 12h128a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12zm-24.88 56c0 .86.07 1.72.07 2.61 0 26.67-20.31 57.44-57.46 57.44a56.79 56.79 0 0 1-31-9.06 36.45 36.45 0 0 0 4.83.28 40.59 40.59 0 0 0 25-8.61 20.39 20.39 0 0 1-18.8-14.11 18 18 0 0 0 3.83.34 20.13 20.13 0 0 0 5.29-.66 20.28 20.28 0 0 1-16.17-19.84v-.22a19.92 19.92 0 0 0 9.12 2.49 20.2 20.2 0 0 1-6.21-27 57.16 57.16 0 0 0 41.61 21.13 20.87 20.87 0 0 1-.47-4.6 20.18 20.18 0 0 1 34.92-13.8 40.32 40.32 0 0 0 12.8-4.89 20.06 20.06 0 0 1-8.88 11.16 42 42 0 0 0 11.63-3.19A40.16 40.16 0 0 1 115.12 56z"
                  data-name="04.Twitter"
                />
              </g>
            </g>
          </svg>
        </a>
      </li>
      <li>
        <a
          href="https://www.trustpilot.com/review/bettermood.com"
          title="Better Mood TrustPilot Reviews">
          <svg
            width="30"
            height="30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={dark ? 'dark' : 'light'}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.5 0A2.5 2.5 0 0 0 0 2.5v25A2.5 2.5 0 0 0 2.5 30h25a2.5 2.5 0 0 0 2.5-2.5v-25A2.5 2.5 0 0 0 27.5 0h-25ZM26 11.996h-8.401L15.004 4l-2.603 7.996L4 11.988l6.803 4.946-2.602 7.988 6.803-4.939 6.795 4.939-2.594-7.988L26 11.996Zm-6.795 4.938-4.2 3.049 4.783-1.24-.583-1.809Z"
              fill="#000"
            />
          </svg>
        </a>
      </li>
    </ul>
  );
}
